import { useState } from 'react';

import { FolderDetails, MainFolders, ShareFolderModal } from './components';
import { useFolderTree } from './context';

export const Folders = () => {
  const { selectedFolder } = useFolderTree();
  const [isShareFolderOpen, setShareFolderOpen] = useState(false);

  return (
    <>
      {selectedFolder ? (
        <FolderDetails
          selectedFolder={selectedFolder}
          onShareFolderClick={() => setShareFolderOpen(true)}
        />
      ) : (
        <MainFolders />
      )}

      {isShareFolderOpen && (
        <ShareFolderModal onDismiss={() => setShareFolderOpen(false)} />
      )}
    </>
  );
};
